"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelContextController = void 0;
var tslib_1 = require("tslib");
var __1 = require("../..");
var react_1 = require("react");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var web_1 = require("@react-keycloak/web");
var hooks_1 = require("../../hooks");
var keycloak_1 = require("../../infra/keycloak");
var useChannelContextController = function () {
    var keycloak = (0, web_1.useKeycloak)().keycloak;
    var clearAllItems = (0, __1.useCartContext)().clearAllItems;
    var initialUser = __1.KeycloakHelper.getTokenParsed(keycloak);
    var _a = (0, react_1.useState)(initialUser), user = _a[0], setUser = _a[1];
    var _b = (0, react_1.useState)([]), associatedMasterDealerIds = _b[0], setAssociatedMasterDealerIds = _b[1];
    var _c = (0, hooks_1.usePersistedStateObject)('selectedMasterDealerId', initialUser === null || initialUser === void 0 ? void 0 : initialUser.email, null), selectedMasterDealerId = _c[0], setSelectedMasterDealerId = _c[1];
    var _d = (0, hooks_1.usePersistedStateObject)('selectedChannel', initialUser === null || initialUser === void 0 ? void 0 : initialUser.email, null), selectedChannel = _d[0], setSelectedChannel = _d[1];
    var _e = (0, react_1.useState)(null), hasCoop = _e[0], setHasCoop = _e[1];
    var _f = (0, react_1.useState)(null), allowanceUsed = _f[0], setAllowanceUsed = _f[1];
    var _g = (0, react_1.useState)(null), allowance = _g[0], setAllowance = _g[1];
    var _h = (0, react_1.useState)([]), groups = _h[0], setGroups = _h[1];
    var _j = (0, react_1.useState)(null), availableBalance = _j[0], setAvailableBalance = _j[1];
    var _k = (0, react_1.useState)(null), masterDealerBalance = _k[0], setMasterDealerBalance = _k[1];
    var _l = (0, react_1.useState)(true), isCoopUpdating = _l[0], setCoopUpdating = _l[1];
    var setState = (0, react_1.useCallback)(function (masterDealerId, channel) {
        // console.log(
        //   `setting masterDealerId to: ${masterDealerId}, setting selectedChannel to: ${channel}`
        // )
        setSelectedMasterDealerId(masterDealerId);
        setSelectedChannel(channel);
        clearAllItems();
    }, [clearAllItems, setSelectedChannel, setSelectedMasterDealerId]);
    var refreshUserData = function () {
        var refreshedUser = __1.KeycloakHelper.getTokenParsed(keycloak);
        setUser(refreshedUser);
        setSelectedMasterDealerId(null);
        setSelectedChannel(null);
    };
    var getAuthorizedConfig = function (config) {
        var _a;
        if (config === void 0) { config = {}; }
        var token = __1.KeycloakHelper.getToken(keycloak_1.keycloakClient);
        if (!token) {
            console.log('[ChannelController] Authorization header missing');
            return config;
        }
        var headers = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, ((_a = config.headers) !== null && _a !== void 0 ? _a : {})), { Authorization: "Bearer ".concat(token) });
        console.log('[ChannelController] Authorization header', headers.Authorization);
        return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, config), { headers: headers });
    };
    var updateBalance = (0, react_1.useCallback)(function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
        var params, data, error_1;
        var _a, _b, _c;
        return (0, tslib_1.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    params = {
                        masterDealerId: __1.ChannelHelper.getMasterDealerId(selectedMasterDealerId, selectedChannel === null || selectedChannel === undefined
                            ? null
                            : selectedChannel.toUpperCase()),
                        emailAddress: user === null || user === void 0 ? void 0 : user.email,
                    };
                    if (!params.masterDealerId || !params.emailAddress) {
                        return [2 /*return*/];
                    }
                    setCoopUpdating(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    ;
                    return [4 /*yield*/, axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/Balance"), null, getAuthorizedConfig({ params: params }))];
                case 2:
                    (data = (_d.sent()).data);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    if (((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status) !== 200 ||
                        ((_c = (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.ErrorOccured)) {
                        setMasterDealerBalance(0.0);
                        setAvailableBalance(0.0);
                        setAllowanceUsed(false);
                        setAllowance(0.0);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    setMasterDealerBalance(!isNaN(data === null || data === void 0 ? void 0 : data.MasterDealerBalance) && data.MasterDealerBalance > 0
                        ? data.MasterDealerBalance
                        : 0.0);
                    setAvailableBalance(!isNaN(data === null || data === void 0 ? void 0 : data.Balance) && data.Balance > 0 ? data.Balance : 0.0);
                    setAllowanceUsed((data === null || data === void 0 ? void 0 : data.AllowanceUsed) === true);
                    setAllowance(!isNaN(data === null || data === void 0 ? void 0 : data.Allowance) && data.Allowance > 0 ? data.Allowance : 0.0);
                    setCoopUpdating(false);
                    return [2 /*return*/];
            }
        });
    }); }, [selectedChannel, selectedMasterDealerId, user]);
    (0, react_1.useEffect)(function () {
        var newUser = __1.KeycloakHelper.getTokenParsed(keycloak);
        setUser(newUser);
    });
    (0, react_1.useEffect)(function () {
        function getUserInfo() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var data, mds, i, l, availableChannel;
                return (0, tslib_1.__generator)(this, function (_m) {
                    switch (_m.label) {
                        case 0: return [4 /*yield*/, __1.httpUserInfo.get({
                                url: "/dealer/".concat(user === null || user === void 0 ? void 0 : user.email),
                            })];
                        case 1:
                            data = (_m.sent()).data;
                            mds = (_a = data === null || data === void 0 ? void 0 : data.dealer) === null || _a === void 0 ? void 0 : _a.associatedMasterDealers;
                            if ((0, __1.isNonEmptyArray)(data === null || data === void 0 ? void 0 : data.dealerTypes) &&
                                (0, __1.isNonEmptyArray)((_b = data === null || data === void 0 ? void 0 : data.dealer) === null || _b === void 0 ? void 0 : _b.associatedMasterDealers)) {
                                for (i = 0, l = (_c = data === null || data === void 0 ? void 0 : data.dealer) === null || _c === void 0 ? void 0 : _c.associatedMasterDealers.length; i < l; ++i) {
                                    data.dealer.associatedMasterDealers[i].dealerTypes =
                                        data === null || data === void 0 ? void 0 : data.dealerTypes;
                                }
                            }
                            setAssociatedMasterDealerIds(mds);
                            availableChannel = ((_d = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _d === void 0 ? void 0 : _d.channels) && ((_e = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _e === void 0 ? void 0 : _e.channels.length) > 0
                                ? mds === null || mds === void 0 ? void 0 : mds[0].channels[0].toUpperCase()
                                : ((_f = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _f === void 0 ? void 0 : _f.masterDealer.channels) &&
                                    ((_g = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _g === void 0 ? void 0 : _g.masterDealer.channels.length) > 0
                                    ? (_h = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _h === void 0 ? void 0 : _h.masterDealer.channels[0].toUpperCase()
                                    : null;
                            !selectedMasterDealerId &&
                                setSelectedMasterDealerId((_j = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _j === void 0 ? void 0 : _j.masterDealerId);
                            if (!selectedChannel) {
                                if (!availableChannel) {
                                    setSelectedChannel((_k = mds === null || mds === void 0 ? void 0 : mds[0]) === null || _k === void 0 ? void 0 : _k.masterDealer[0].channels[0].toUpperCase());
                                }
                                else {
                                    setSelectedChannel(availableChannel);
                                }
                            }
                            // !selectedChannel &&
                            //   setSelectedChannel(mds?.[0]?.masterDealer[0].channels[0].toUpperCase())
                            setHasCoop((_l = data === null || data === void 0 ? void 0 : data.dealer) === null || _l === void 0 ? void 0 : _l.hasCoop);
                            setGroups(data === null || data === void 0 ? void 0 : data.groups);
                            return [2 /*return*/];
                    }
                });
            });
        }
        (user === null || user === void 0 ? void 0 : user.email) && getUserInfo();
    }, [
        selectedChannel,
        selectedMasterDealerId,
        setSelectedChannel,
        setSelectedMasterDealerId,
        user === null || user === void 0 ? void 0 : user.email,
    ]);
    (0, react_1.useEffect)(function () {
        updateBalance();
    }, [updateBalance]);
    return {
        associatedMasterDealerIds: associatedMasterDealerIds,
        selectedMasterDealerId: selectedMasterDealerId,
        selectedChannel: selectedChannel === null || selectedChannel === undefined
            ? null
            : selectedChannel.toUpperCase(),
        hasCoop: hasCoop,
        groups: groups,
        coop: {
            hasCoop: hasCoop,
            masterDealerBalance: masterDealerBalance,
            availableBalance: availableBalance,
            isCoopUpdating: isCoopUpdating,
            allowanceUsed: allowanceUsed,
            allowance: allowance,
        },
        setState: setState,
        updateBalance: updateBalance,
        refreshUserData: refreshUserData,
    };
};
exports.useChannelContextController = useChannelContextController;
